// extracted by mini-css-extract-plugin
export default {"container":"style_container__-r5wq","card":"style_card__XCSfF","footer":"style_footer__h6Z5Q","submitButton":"style_submitButton__QwTNX"};